module.exports = __webpack_public_path__ + "static/media/coverImages.da7a03af.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/SuperUser/img/coverImages.png
// module id = 988
// module chunks = 0